import React, { useState, useEffect } from 'react';
import { Modal, Spin, message, Select } from 'antd';

export const BulkAssignModal = ({ visible, onClose, selectedCount, songs, onConfirm, loading = false }) => {
    const [selectedSongId, setSelectedSongId] = useState(null);

    useEffect(() => {
        if (!visible) {
            setSelectedSongId(null);
        }
    }, [visible]);

    const handleConfirm = async () => {
        if (!selectedSongId) {
            message.error('Please select a song');
            return;
        }
        await onConfirm(selectedSongId);
    };

    const handleCancel = () => {
        setSelectedSongId(null);
        onClose();
    };

    const options = [
        {
            label: 'No Song',
            value: null
        },
        ...songs.map(song => ({
            label: song.song_name,
            value: song.id
        }))
    ];

    return (
        <Modal
            title="Bulk Assign Song"
            open={visible}
            onCancel={handleCancel}
            onOk={handleConfirm}
            confirmLoading={loading}
            okText="Assign"
            cancelText="Cancel"
        >
            <Spin spinning={loading}>
                <div style={{ paddingTop: '16px' }}>
                    <p>
                        Assign a song to <strong>{selectedCount}</strong> recording{selectedCount !== 1 ? 's' : ''}
                    </p>
                    <div style={{ marginTop: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                            Song
                        </label>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Select a song"
                            value={selectedSongId}
                            onChange={setSelectedSongId}
                            options={options}
                            allowClear
                            labelInValue={false}
                        />
                    </div>
                </div>
            </Spin>
        </Modal>
    );
};
